import type { cs } from "./cs"

export const en: typeof cs = {
    translation: {
        minimumStayDetail: {
            minimum_one: 'The garage has a minimum reservation length of {{count}}\u00a0hour.',
            minimum_few: 'The garage has a minimum reservation length of {{count}}\u00a0hours.',
            minimum_many: 'The garage has a minimum reservation length of {{count}}\u00a0hours.',
            minimum_other: 'The garage has a minimum reservation length of {{count}}\u00a0hours.',
            until: 'You can therefore park until {{endsAt}}.',
            untilMidnight: 'You can therefore park until midnight.',
            untilWeekday: 'You can therefore park until {{weekday}} {{endsAt}}.',
        },
        minimumStayPrice: {
            unavailable: 'The price could not be loaded. Please try again.',
            availabilityUnavailable: 'Availability could not be checked. Please try again.',
            duration_one: 'Price for {{count}} hour.',
            duration_few: 'Price for {{count}} hours.',
            duration_many: 'Price for {{count}} hours.',
            duration_other: 'Price for {{count}} hours.',
            until: 'You can park until {{endsAt}}.',
            untilMidnight: 'You can park until midnight.',
            untilWeekday: 'You can park until {{weekday}} {{endsAt}}.',
            weekdays: {
                0: 'Sunday',
                1: 'Monday',
                2: 'Tuesday',
                3: 'Wednesday',
                4: 'Thursday',
                5: 'Friday',
                6: 'Saturday',
            },
        },
        general: {
            bookNow: 'Book now',
            bookNowFor: 'Book now for',
            cannotBook: 'Cannot book',
            unavailable: 'Unavailable',
            someGaragesInvalidPeriod: 'Some garages cannot be booked for the selected period:',
            detail: 'Detail',
            czk: 'CZK',
            occupied: 'Occupied',
            occupiedShort: 'Full',
            min: 'Min.',
            hours: 'hours',
            hoursShortcut: 'h',
            list: 'List',
            map: 'Map',
            filters: 'Filters',
            hide: 'Hide',
            garagesFound_one: '<strong>{{count}} garage</strong> found',
            garagesFound_few: '<strong>{{count}} garages</strong> found',
            garagesFound_many: '<strong>{{count}} garages</strong> found',
            garagesFound_other: '<strong>{{count}} garages</strong> found',
            garagesAvailableLaterGeneric: 'Seems like a lot of garages are fully booked at this time. Set the reservation start time to <strong>{{from}} - {{to}}</strong> and more garages will be available.',
            garagesAvailableAtTime_one: 'Seems like a lot of garages are fully booked at this time. Set the reservation start time to <strong>{{time}}</strong> and there will be <strong>{{count}} more garage available</strong>.',
            garagesAvailableAtTime_few: 'Seems like a lot of garages are fully booked at this time. Set the reservation start time to <strong>{{time}}</strong> and there will be <strong>{{count}} more garages available</strong>.',
            garagesAvailableAtTime_many: 'Seems like a lot of garages are fully booked at this time. Set the reservation start time to <strong>{{time}}</strong> and there will be <strong>{{count}} more garages available</strong>.',
            garagesAvailableAtTime_other: 'Seems like a lot of garages are fully booked at this time. Set the reservation start time to <strong>{{time}}</strong> and there will be <strong>{{count}} more garages available</strong>.',
            moveToTimeWithCount_one: 'Start at {{time}} (+{{count}} garage)',
            moveToTimeWithCount_few: 'Start at {{time}} (+{{count}} garages)',
            moveToTimeWithCount_many: 'Start at {{time}} (+{{count}} garages)',
            moveToTimeWithCount_other: 'Start at {{time}} (+{{count}} garages)',
            fromTime: 'From {{time}}',
            moveToTime: 'Start at {{time}}',
            setStartToTime: 'Set start time to {{time}}',
            startTimeMoved: 'Reservation start moved to {{time}}',
            undo: 'Undo',
            garageAvailableLaterDetail: 'This garage has capacity available from {{time}}.',
            close: 'Close',
            lastPlacesAvailable: 'Last places',
            boolean: {
                true: 'Yes',
                false: 'No'
            },
            phoneInput: {
                searchPlaceholder: "Select the country code",
            },
            resetChanges: 'Reset changes',
            confirmFormClear: 'Confirm form reset',
            cancel: 'Cancel',
            confirm: 'Confirm',
        },
        filters: {
            showAvailable: 'Show only available garages',
            yesShow: 'Yes',
            priceRange: 'Price range',
            carHeight: 'Maximum car height',
            carWidth: 'Maximum car width',
            carLength: 'Maximum car length',
            carWeight: 'Maximum car weight',
            sortBy: 'Sort by',
            distance: 'Distance',
            price: 'Price',
            parkingType: 'Type',
            all: 'All',
            garage: 'Garage',
            parkingLot: 'Parking lot',
            restrictions: 'Show only garages where allowed',
            electricAllowed: 'Electric cars',
            lpgCngAllowed: 'LPG & CNG',
            motorbikesAllowed: 'Motorbikes',
            remove: 'Remove filters',
            reset: 'Reset filters',
            showResults: 'Show results',
            noResultsMatch: 'No garages match these filters.',
        },
        search: {
            reset: 'Reset',
            edit: 'Edit',
            search: 'Search',
            where: 'Where do you want to park?',
            wherePlaceholder: 'City, Street, Place...',
            whereEmpty: 'No suggestions',
            start: 'Reservation from',
            end: 'Reservation until',
            label: 'When and where to park?',
            reservationStart: 'Reservation from',
            reservationEnd: 'Reservation until',
            reservationLength: 'Reservation length',
            pricePerHour: 'Price / hour',
            reservationExtendedLength: 'Extended reservation length',
            reservationDate: 'Reservation date',
            days_one: ' {{count}} day',
            days_few: ' {{count}} days',
            days_many: ' {{count}} days',
            days_other: ' {{count}} days',
            hours_one: ' {{count}} hour',
            hours_few: ' {{count}} hours',
            hours_many: ' {{count}} hours',
            hours_other: ' {{count}} hours',
            minutes_one: ' {{count}} minute',
            minutes_few: ' {{count}} minutes',
            minutes_many: ' {{count}} minutes',
            minutes_other: ' {{count}} minutes',
            selectDate: 'Select start date and end date',
            arrivalAfter: 'Arrive after',
            departureBefore: 'Depart before',
            selectStart: 'Please use the calendar to select reservation start date',
            selectEnd: 'Please use the calendar to select reservation end date',
            startInThePast: 'Your reservation starts in the past!',
            discountAvailable: 'Reserve at least 7 days and get a <strong>15% discount</strong> with the code <strong>PREMIUM7</strong>.',
            invalidTimeRange: 'Select a valid period ending after the reservation starts.',
            defaultLocation: 'Parking in Prague',
            selectExtensionStart: 'Select new reservation START DATE in the calendar (or select current start date to keep it).',
            selectExtensionEnd: 'Select new reservation END DATE in the calendar (or select current end date to keep it).',
            extensionStartsTooLate: 'Extended reservation cannot start later than original reservation.',
            extensionEndsTooEarly: 'Extended reservation cannot end sooner than original reservation.',
            extensionIntoThePast: 'You are trying to extend the reservation into the past.',
            checkAvailability: 'Check availability',
            sendExtensionRequest: 'Send extension request',
            return: 'Return',
            extendReservation: 'Extend reservation',
            extensionPossible: 'It is possible to extend your reservation!',
            extensionPrice: 'Extension price: {{price}} CZK',
            originalExtensionPrice: 'Original extension price',
            extensionTotal: 'Total for extension',
            payToContinue: 'To confirm the extension, please pay the price difference.',
            toPaymentCTA: 'To payment',
        },
        routes: {
            garages: 'garages',
            reservations: 'reservations',
            reservations_steps: {
                reservation_time: 'reservation-time',
            },
            users: 'users',
            signIn: 'sign-in',
            register: 'sign-up',
            signOut: 'sign-out',
        },
        reservations: {
            status: {
                booked: 'Booked',
                current: 'Current',
                elapsed: 'Elapsed',
                cancelled: 'Cancelled',
                allocated: 'Allocated',
            },
            general: {
                active: 'Current reservations',
                all: 'All reservations',
                noBooked: 'You don\'t have any current or future reservations.',
                noBookedCreate: 'Book now',
                remaining: 'Remaining:',
            },
            filters: {
                sortBy: 'Sort by',
                id: 'ID',
                startAt: 'Reservation start',
                status: 'Status filter',
                all: 'All',
                active: 'Current',
                elapsed: 'Elapsed',
                cancelled: 'Cancelled',
                allocated: 'Allocated',
            },
            table: {
                reservation: 'Reservation',
                garage: 'Garage',
                unit: 'Place',
                driver: 'Driver',
                licensePlate: 'Plate',
                phone: 'Phone',
                date: 'Date',
                price: 'Price',
                createdAt: 'Created at',
                garageAndUnit: 'Garage and place',
                from: 'From',
                to: 'To',
                phoneNumbers: 'Phone numbers',
                cancelReservation: 'Cancel',
                editDetails: 'Edit Plate/Phone',
                bookNextDay: 'Repeat booking for next day',
                bookTomorrow: 'Book from tomorrow',
                bookAgain: 'Book the same garage again',
                paymentInProgress: 'Payment is being processed. Please wait for confirmation.',
                changeUnitApprove: 'To complete the parking space change, please confirm the garage rules.',
                confirm: 'Confirm',
                openGarage: 'Garage detail'
            },
            unpaid: {
                unfinishedReservation: {
                    alert: 'To complete your reservation, continue to payment.',
                    button: 'To payment',
                },
                prolongation: {
                    alert: 'Please pay {{price}} {{currency}} to complete your reservation extension.',
                    button: 'Pay extension',
                },
                changeUnit: {
                    alert: 'Please pay {{price}} {{currency}} to complete your parking space change.',
                    button: 'Pay for space change',
                },
            },
            documents: {
                tickets: 'Tickets',
                invoices: 'Invoices',
                invoiceCorrections: 'Invoice corrections',
                creditNotes: 'Credit notes',
                other: 'Other documents',
                termsOfService: 'Terms of service',
                privacyPolicy: 'Privacy policy',
                garageOperatingTerms: 'Garage operating terms',
            },
            active: {
                open: 'Open',
                slideToOpen: 'Slide to open',
                entrance: 'entrance',
                exit: 'exit',
                reception: 'reception',
                extend: 'Extend',
                cancel: 'Cancel',
                confirm: 'Confirm',
                ending: 'Ending',
                starting: 'Starting',
                ended: 'Ended',
                cancelNotPossible: 'It is not possible to cancel your reservation:',
                cancelSuccessful: 'Your reservation has been successfully cancelled.',
            },
            edit: {
                save: 'Save',
                cancel: 'Cancel',
                clear: 'Clear',
                phoneNumber1: 'Phone number 1',
                phoneNumber2: 'Phone number 2',
                licensePlate: 'License plate',
            },
            cancel: {
                confirmation: 'Do you really wish to cancel this reservation?',
                detail: 'Once the reservation is cancelled, it cannot be renewed.',
                cancel: 'Cancel reservation',
                keep: 'Keep it',
            },
            empty: {
                title: 'You have not made any reservation yet',
                text: 'Create a new reservation. You will then be able to see all your reservations here.'
            },
            reportOccupiedUnit: {
                button: 'Occupied space',
                title: 'Report occupied parking space',
                subtitle: 'Is someone parking on your assigned parking space? Please fill in the details below and we will resolve it shortly.',
                buttonText: 'Report',
                cancel: 'Cancel',
                offendantNumberPlate: 'License plate of the offending car',
                yourReservationNumber: 'Your reservation number',
                yourEmail: 'Your email',
                stateCreated: 'A request to change the assigned parking space created',
                stateOpen: 'The request to change the assigned parking space is being resolved',
                stateClosed: 'The request to change the assigned parking space has been resolved',
            },
        },
        profile: {
            refetch: 'Try again',
            languageSelector: 'Select language',
            currencySelector: 'Select currency',
            signOut: 'Sign out',
            userProfile: {
                title: "User profile",
                edit_title: "Edit user profile",
                edit_save: "Edit",
                email: "Email",
                userName: "Full name",
                phoneNumber1: "Phone n.1",
                phoneNumber1Tooltip: "Used for opening the garage",
                phoneNumber2: "Phone n.2",
                agreedToMarketing: "Consent to marketing communication",
                edit_agreedToMarketing: "Consent to marketing communication",
                prefillCheckoutInfo: "Prefill reservation details",
                edit_prefillCheckoutInfo: "Prefill reservation details",
            },
            invoiceDetails: {
                title: "Billing details",
                edit_title: "Edit billing details",
                edit_save: "Edit",
                empty: "Not added yet",
                invoice_title: "Company name",
                invoice_street: "Address Line 1",
                invoice_city: "City",
                invoice_zip_code: "ZIP code",
                invoice_country: "Country",
                invoice_ic: "Company number",
                invoice_dic: "VAT number",
            },
            cars: {
                title: "Vehicles",
                edit_title: "Edit vehicle",
                edit_save: "Edit",
                add_title: "Add vehicle",
                add_confirm: "Add",
                name: "Name",
                numberPlate: "License plate",
                color: "Colour",
                add: "Add"
            }
        },
        checkout: {
            actions: {
                back: 'Back',
                toPaymentCTA: 'Pay',
            },
            cancellationAlert: {
                heading: 'Free cancellation anytime before start',
                bullet1: 'You can cancel your reservation at any time before the parking starts.',
                bullet2: 'You can do this in the app, via the link in the confirmation email, or by contacting customer support.',
                bullet3: 'Once the reservation period has started, it cannot be canceled, not even partially.',
            },
            unsupportedIosApp: {
                title: 'Update MR.PARKIT to continue',
                description: 'This version of MR.PARKIT is no longer supported. Update to the latest version from the App Store to create or pay for a reservation.',
                updateApp: 'Update in App Store',
            },
            errors: {
                expiredTitle: 'The reservation has expired',
                expiredText: 'This reservation can no longer be completed. Please choose a garage again and create a new reservation.',
                backToGarageList: 'Back to garage selection',
                unavailable: 'Checkout reservation is no longer available. Please create a new reservation.',
            },
            booked: {
                title: 'Reservation completed',
                text: 'This reservation has already been paid and confirmed.',
                myReservations: 'Go to My reservations',
            },
            paymentResolution: {
                checking: 'We’re checking the status of your payment. Please wait.',
            },
            termsOfServiceHtml: '<checkboxLabel>I request that the service be provided on the date as reserved and I agree with </checkboxLabel><termsLink>the Terms and Conditions of Service</termsLink><checkboxLabel>, </checkboxLabel><privacyPolicyLink>Personal Data Protection Policy</privacyPolicyLink><checkboxLabel> as well as </checkboxLabel><garageTermsLink>the Operating Rules</garageTermsLink><checkboxLabel>.</checkboxLabel>',
            sendSms: "I already know the garage, I don't need the instructions to SMS again and/or I use the app to open.",
            disclaimer: {
                validation: {
                    required: 'Please confirm the terms before continuing.',
                },
            },
            contactInfo: {
                heading: 'Contact',
                edit: 'Edit',
                save: 'Save',
                cancel: 'Cancel',
                clear: 'Clear',
                name: 'Full name',
                email: 'Email',
                emailSuggestion: 'Did you mean {{email}}?',
                phoneNumber1: 'Phone n.1',
                phoneNumber2: 'Phone n.2',
                invoiceHeading: 'Billing details',
                invoiceTitle: 'Company name',
                mandatoryInvoiceTitle: 'Name/Company name',
                invoiceStreet: 'Address Line 1',
                invoiceCity: 'City',
                invoiceZipCode: 'ZIP code',
                invoiceCountry: 'Country',
                countryNoOptions: 'No matching country',
                invoiceIc: 'Company number',
                invoiceDic: 'VAT number',
                addPhoneNumber: 'Add another phone',
                additionalPhoneInfo: 'These phone numbers are authorized for opening the garage by calling.',
                invoiceRequest: 'A normal tax document is not enough for me - I need an invoice for company accounting.',
                validation: {
                    required: 'Please fill in this field.',
                    invalidEmail: 'Please enter a valid email address.',
                    invalidPhone: 'Please enter a valid phone number.',
                },
            },
            vehicleInfo: {
                heading: 'Vehicle',
                edit: 'Edit',
                save: 'Save',
                cancel: 'Cancel',
                clear: 'Clear',
                numberPlate: 'License plate',
                carColor: 'Car color',
                addNow: 'Add now',
                addLater: 'Add later',
                savedCarsLabel: 'Choose vehicle',
                customOption: 'Other...',
                addLaterSelected: 'I will add it later in the app',
                addLaterDescription: 'You can add the vehicle plate in the app any time before arrival.',
                validation: {
                    required: 'Please fill in this field.',
                },
            },
            discountCode: {
                // heading: 'Discount code',
                label: 'Discount code',
                apply: 'Apply',
                addCode: 'Add discount code',
                changeCode: 'Enter another',
                removeCode: 'Remove discount code',
                applied: 'Discount code {{code}} applied',
                appliedPercentage: 'Discount code {{code}} applied - {{discount}}% discount',
                appliedAmount: 'Discount code {{code}} applied - discount {{discount}} CZK',
                validation: {
                    required: 'Please enter a discount code.',
                },
            },
            benefitCodePayment: {
                reveal: 'Reserve with booking code',
                label: 'Booking code',
                placeholder: 'Select a booking code',
                submit: 'Reserve with booking code',
                cancel: 'Cancel',
                validation: {
                    required: 'Please choose a booking code.',
                },
            },
            extensionAlert: {
                heading_one: 'Reservation extended to {{count}}\u00a0hour',
                heading_few: 'Reservation extended to {{count}}\u00a0hours',
                heading_many: 'Reservation extended to {{count}}\u00a0hours',
                heading_other: 'Reservation extended to {{count}}\u00a0hours',
                explanation: 'We have therefore automatically extended your reservation.',
                until: 'You can park until {{endsAt}} for the same price.',
                untilMidnight: 'You can park until midnight for the same price.',
                untilWeekday: 'You can park until {{weekday}} {{endsAt}} for the same price.',
            },
            orderSummary: {
                start: 'Start',
                end: 'End',
                duration: 'Duration',
                originalPrice: 'Original price',
                discount: 'Discount',
                total: 'Total',
                identificationNumber: 'No.',
                vatPayer: 'VAT payer',
                notVatPayer: 'Supplier is not VAT payer',
                vatIncluded: 'incl. VAT',
            },
            paymentResult: {
                missingPaymentId: 'Missing payment reference.',
                missingReservationToken: 'Missing checkout context. Please go back to checkout and try again.',
                genericError: 'Unable to start payment. Please try again.',
                redirectingToStripe: 'Redirecting to Stripe…',
                continueToStripeHostedPayment: 'Continue to Stripe-hosted payment',
                continueToPayment: 'Continue to payment',
                backToHomepage: 'Back to homepage',
                backToCheckout: 'Back to checkout',
            },
        },
        success: {
            newsletterBanner: {
                title: 'Don’t miss news and special offers',
                button: 'Subscribe to news',
                success: 'Thank you for subscribing.',
                error: 'We could not subscribe you to our news. Please try again.',
            },
            appBanner: {
                title: 'Make parking even simpler with our mobile app',
                feature1: 'Edit or cancel reservations easily',
                feature2: 'Open the garage conveniently with a button instead of calling',
                feature3: 'Book even faster without re-entering your details',
                feature4: 'Keep all billing documents in one place',
                androidAlt: 'Install on Android',
                iphoneAlt: 'Install on iPhone',
                visualAlt: 'QR code and preview of the Mr. Parkit mobile app',
            },
            congratulations: {
                title: 'Successful reservation! Thank you.',
                imageAlt: 'Illustrative picture of the reservation',
                text: 'We have emailed a parking ticket with your reservation details to the provided email address. For your convenience, we have also sent you everything in a text message to the phone numbers you provided.The parking space must be vacated by the end of the reservation at the latest!',
                textWithoutSms: 'We have emailed a parking ticket with your reservation details to the provided email address. You can manage your reservation in My reservations. The parking space must be vacated by the end of the reservation at the latest!',
                myReservationsLink: 'Continue to My reservations',
            },
            prolongation: {
                congratulations: {
                    title: 'Reservation extended successfully',
                    imageAlt: 'Illustrative picture of a successful reservation extension',
                    text: 'Your reservation extension has been confirmed successfully. We will send the updated confirmation by email and SMS.',
                },
                failed: {
                    title: 'Reservation prolongation failed',
                    text: 'We could not confirm the reservation extension payment. Please try again from the reservation detail.',
                },
                pending: {
                    title: 'Waiting for prolongation payment confirmation',
                    imageAlt: 'Illustrative picture of a pending reservation extension',
                    text: 'The reservation extension payment has not been confirmed yet. Please wait for completion.',
                },
                returnLink: 'Back to reservation',
            },
            changeUnit: {
                congratulations: {
                    title: 'Parking space changed successfully',
                    imageAlt: 'Illustrative picture of a successful parking space change',
                    text: 'Your parking space change payment has been confirmed. We will send the updated confirmation by email and SMS.',
                },
                failed: {
                    title: 'Parking space change payment failed',
                    text: 'We could not confirm the payment for your parking space change. Please try again from the reservation detail.',
                },
                pending: {
                    title: 'Waiting for parking space change payment confirmation',
                    imageAlt: 'Illustrative picture of a pending parking space change',
                    text: 'The parking space change payment has not been confirmed yet. Please wait for completion.',
                },
                returnLink: 'Back to reservation',
            },
            failed: {
                title: 'Reservation failed',
                imageAlt: 'Illustrative picture of a failed reservation',
                text: 'The most probable reason is that took you over 30 minutes to finish payment and the reservation expired in the meantime. We will cancel the payment and refund your money. Please try to repeat the reservation.',
                repeatLink: 'Repeat reservation',
            },
            pending: {
                title: 'Waiting for payment confirmation',
                imageAlt: 'Illustrative picture of a pending reservation',
                text: 'Payment has not been confirmed yet. Please wait for completion. We will send confirmation by email and SMS once the payment is confirmed.',
                repeatLink: 'Repeat reservation',
            },
            summary: { 
                title: 'Reservation confirmation',
                continueToMyReservations: 'Please continue to My reservations to view the reservation detail.',
                debugFetchErrorsIntro: 'There were errors while loading reservation detail in this view:',
            },
            reservationSummary: {
                totalPrice: 'Total price',
                vatIncluded: 'incl. VAT',
                email: 'E-mail',
                name: 'Name',
                numberPlate: 'Plate',
                carColor: 'Color',
                floorWithNumber:'Floor / Parking space',
                phoneNumber:'Phone',
                phoneNumber2:'Phone n.2',
            }
        },
        garage: {
            car_dimensions: {
                title: 'Maximum dimensions',
                titleWithWeight: 'Maximum dimensions and weight',
                height: 'Height',
                length: 'Length',
                weight: 'Weight',
                width: 'Width',
            },
            showLess: 'Show less',
            showMore: 'Show more',
            mainBenefits: {
                first: 'Repeated entry and exit',
                second: 'Instructions in email and SMS',
                third: 'Easy cancellation and change of the reservation',
            },
            openOnMap: 'Navigate',
            showInstructions: "Important instructions",
            instructionsHeading: "Important instructions for arrival/departure",
            benefits: {
                title: 'Specifications',
                list: {
                    '10_minutes_form_city_center': '10 minutes from city centre',
                    '15_minutes_from_city_center': '15 minutes from city centre',
                    '5_minutes_form_city_center': '5 minutes from city centre ',
                    call_reception: 'Please call reception upon arrival.',
                    cctv: 'CCTV',
                    cctv_at_entrance: 'CCTV at entrance',
                    city_center: 'City centre',
                    historic_city_center: 'Historical city centre',
                    charging_station: 'Charging for EV',
                    licence_plate_validation: 'Entrance barrier opens with license plate recognition',
                    limited_vehicle_dimensions: 'Limited vehicle dimensions',
                    main_reception: 'You can gain access to the garage at the building\'s main reception in the lobby - only then can you enter the garage.',
                    nonstop_operation: 'Non-stop operation',
                    nonstop_reception: 'Non-stop reception',
                    nonstop_service: 'Non-stop operation',
                    number_plate_recognition: 'The camera reads your licence plate no. and opens the barrier',
                    open_gate_by_attendant: 'The gate will be opened by an attendant',
                    open_gate_by_phone: 'You open the gate with your phone',
                    parking_for_disabled: 'Kamerový systém u vjezdu',
                    security_system: 'Bezpečnostní systém',
                    subway_availability: 'Tramvaj v blízkosti',
                    tram_availability: 'Metro v blízkosti',
                    wc: 'WC',
                },
            },
            prohibitions: {
                title: 'Bans',
                list: {
                    lpg_cng_not_allowed: 'LPG und CNG nicht erlaubt',
                    electric_car_not_allowed: 'Parking of electric cars prohibited',
                    motorbikes_not_allowed: 'No motorcycle parking',
                },
            },
            garage_videos: {
                title: 'Videogallery',
            },
            faq: {
                title: 'Frequently asked questions',
            },
            reservationSummary: {
                minimumStay: {
                    first: 'The minimum reservation time here is',
                    second: 'hours',
                },
            },
            confirmationModal: {
                maxDimensionsTitle: 'Please note',
                cancel: 'Cancel',
                complete: 'Book now',
            }
        },
        loginCrossroads: {
            login: "Log in",
            createAccount: "Register",
        },
        pwa: {
            search: 'Search',
            myReservations: 'My reservations',
            profile: 'Profile',
            myReservationsNoUser: 'You need to log in to manage your reservations and open your garage:',
            profileNoUser: 'To manage your profile, vehicles and invoicing you need to log in'
        },
        error: {
            heading: 'Oops! :(',
            title: 'An unexpected error has occurred',
            titleEmbedded: 'An unexpected error has occurred in this view - the rest of the application is very likely unaffected.',
            textEmbedded: 'Please try moving to a different tab, or restarting the app. You can also contact us through our website on our hotline.',
            moreInfo: 'Here are more details for the developers:'
        },
        support: {
            heading: 'Contact',
            text: 'We are happy to answer your questions during our business hours, Monday to Friday from 9:00 a.m. to 5:00 p.m. Outside of these hours, our non-stop hotline is available for urgent matters regarding current reservations.',
            more: 'More',
        },
    },
}
